/**
 * AssetTagTypeService
 * Service for AssetTagType lookup CRUD operations
 */
import { CrudService } from '../base/CrudService';
/** Service for AssetTagType CRUD operations */
export class AssetTagTypeService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? AssetTagTypeService.DEFAULT_SERVICE_PATH,
            basePath: AssetTagTypeService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
AssetTagTypeService.DEFAULT_SERVICE_PATH = 'assetmanagement';
AssetTagTypeService.BASE_PATH = 'api/asset-tag-types';
//# sourceMappingURL=AssetTagTypeService.js.map